import React from "react";
import { Card, Button } from "react-bootstrap";
import ncGames from "../images/ncGames.png";
import ggoh from "../images/ggoh.png";
import swapz from "../images/swapz.png";
import workInProgress from "../images/workInProgress.png";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Projects = () => {
  return (
    <section id="projects">
      <h2 className="myProjects__title">My Projects</h2>
      <div className="project-container">
        {/* project1 */}
        <div className="project-card" data-testid="ggoh-project">
          <div className="image-container">
            <Card.Img variant="top" src={ggoh} />
          </div>
          <div className="card-body">
            <h3 className="card-title">Front-End/Genre Gaming Opinion Hub</h3>
            <p className="card-text">
              This is React-based website that connects to an API that provides
              users with access to images of games with different categories.
              The user experience is elevated through the ability to click on a
              game card to reveal a review and its accompanying list of
              comments. Users can also leave or remove comments, as well as like
              or dislike a review, which adds an interactive element to the
              website. In addition, the website is equipped with a loading
              spinner and error handling for server issues, ensuring that the
              user experience remains uninterrupted.
            </p>
            <p className="card-tech-stack">
              <span>Tech Stack:</span> React / CSS
            </p>
            <div className="button-container">
              <Button
                target="_blank"
                variant="outline-dark"
                href="https://genregamingopinionhub.netlify.app/"
              >
                Live Demo <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </Button>
              <Button
                target="_blank"
                variant="outline-dark"
                href="https://github.com/vincenzochiovaro/Project-NC-games-FE"
              >
                Code <FontAwesomeIcon icon={faGithub} />
              </Button>
            </div>
          </div>
        </div>
        {/* project2 */}
        <div className="project-card" data-testid="ncGames-project">
          <div className="image-container">
            <Card.Img variant="top" src={ncGames} />
          </div>
          <div className="card-body">
            <h3 className="card-title">Back-End/NC Games</h3>
            <p className="card-text">
              This project is a RESTful API that enables users to interact with
              reviews, comments, and users. The API allows users to view,
              create, update, and delete reviews and comments, and view
              available API endpoints. The project utilizes a TDD approach, with
              tests written using Jest.
            </p>
            <p className="card-tech-stack">
              <span>Tech Stack:</span> Node / Express / PostgreSQL / Jest
            </p>
            <div className="button-container">
              <Button
                target="_blank"
                variant="outline-dark"
                href="https://github.com/vincenzochiovaro/Project-NC-Games"
              >
                Live Demo <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </Button>
              <Button
                variant="outline-dark"
                target="_blank"
                href="https://github.com/vincenzochiovaro/Project-NC-Games"
              >
                Code <FontAwesomeIcon icon={faGithub} />
              </Button>
            </div>
          </div>
        </div>
        {/* project3 */}
        <div className="project-card" data-testid="swapz-project">
          <div className="image-container">
            <Card.Img variant="top" src={swapz} />
          </div>
          <div className="card-body">
            <h3 className="card-title">Full-Stack/Swapz</h3>
            <p className="card-text">
              Swapz is a mobile application that enables users to swap their
              items with others in their local area. Users can register and
              login to the app, view a list of all available items, and access
              individual item pages to view more information. They can comment
              on items or submit swap offers to other users. Users can also view
              offers that have been made on their posted items and visit other
              users' profiles to view their items. The app utilizes React Native
              and Expo Go for its frontend, and Firebase as its
              Backend-as-a-Service (BaaS) platform for data storage, and image
              hosting,
            </p>
            <p className="card-tech-stack">
              <span>Tech Stack:</span> React Native / Expo Go / Firebase /
              Firebase Auth
            </p>
            <div className="button-container">
              <Button
                target="_blank"
                variant="outline-dark"
                href="https://www.youtube.com/watch?v=9dD8mxC-31c&ab_channel=VincenzoChiovaro"
              >
                Live Demo <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </Button>
              <Button
                variant="outline-dark"
                target="_blank"
                href="https://github.com/raulmartinasc/swapz"
              >
                Code <FontAwesomeIcon icon={faGithub} />
              </Button>
            </div>
          </div>
        </div>
        {/* project4 */}
        <div className="project-card" data-testid="mealtime-project">
          <div className="image-container">
            <Card.Img variant="top" src={workInProgress} />
          </div>
          <div className="card-body">
            <h3 className="card-title">Work In Progress</h3>
            <p className="card-text">
              This is a simplified version of the MealDB API, designed to help
              beginners learn how to interact with APIs and create basic
              websites using programming languages. The goal of this project is
              to simplify the MealDB API response to include only the necessary
              information, making it easier for beginners to navigate and
              practice with. <br /> Work In Progress . . .
            </p>
            <p className="card-tech-stack">
              <span>Tech Stack:</span> Node / Express / PostgreSQL / Jest
            </p>
            <div className="button-container">
              <Button
                target="_blank"
                variant="outline-dark"
                href="https://github.com/vincenzochiovaro/Mealtime-backend"
              >
                Live Demo <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </Button>
              <Button
                variant="outline-dark"
                target="_blank"
                href="https://github.com/vincenzochiovaro/Mealtime-backend"
              >
                Code <FontAwesomeIcon icon={faGithub} />
              </Button>
            </div>
          </div>
        </div>
        {/* project5 */}
      </div>
    </section>
  );
};

export default Projects;
